// extracted by mini-css-extract-plugin
export var active = "_8s-d";
export var blink = "_8s-e";
export var container = "_8s-5";
export var controls = "_8s-0";
export var controlsRight = "_8s-1";
export var fakeCursor = "_8s-c";
export var hidden = "_8s-b";
export var quillContainerSmall = "_8s-7";
export var quillEditor = "_8s-6";
export var quillEditorSmall = "_8s-8";
export var quillFormatButtons = "_8s-a";
export var quillToolbar = "_8s-9";
export var removePadding = "_8s-2";
export var state = "_8s-3";
export var stateTitle = "_8s-4";